import { fmtNum } from '../../utils/format';

export default function ResSupTable({ rows }) {
  return (
    <div className="oc-r" id="ocResSup">
      <div className="oc-r-title">RESISTANCE · SUPPORT · SPOT (5‑MIN)</div>
      <table className="rt">
        <thead>
          <tr><th>TIME</th><th>RES</th><th>SPOT</th><th>SUP</th><th>DIV</th></tr>
        </thead>
        <tbody>
          {!rows?.length ? (
            <tr><td colSpan={5} style={{ padding: 12, color: 'var(--text-dim)' }}>No intraday RES/SUP rows for this date.</td></tr>
          ) : rows.map((ts, i) => {
            const dc = ts.divergence === 'Bullish' ? 'dvb' : ts.divergence === 'Bearish' ? 'dvr' : '';
            const dt = ts.divergence === 'Bullish' ? 'Bull' : ts.divergence === 'Bearish' ? 'Bear' : '-';
            return (
              <tr key={i}>
                <td>{ts.time}</td>
                <td className="rr">{ts.strong_resistance ? fmtNum(ts.strong_resistance, 0) : '-'}</td>
                <td>{fmtNum(ts.spot)}</td>
                <td className="rs">{ts.strong_support ? fmtNum(ts.strong_support, 0) : '-'}</td>
                <td className={dc}>{dt}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}